export default {
  all: "*",
  // admin: "Contracts.Placements.Admin",
  // student: "Student",
  // advisor: "Placements.Advisor",
  // contractManager: "Placements.ContractManager",
  // viewer: "Placements.Viewer",
  impersonation: "Impersonation",
  // translationalTeam: "Placements.TranslationalTeam",
  // faculty: "Placements.Faculty"

  // New roles (June 14, 2022, Andrew and Marina)
  contractManager: "Placements.Contracts.Manager",
  contractViewer: "Placements.Contracts.Viewer",
  sitesManager:  "Placements.Sites.Manager",
  sitesViewer:  "Placements.Sites.Viewer",
  opportunitiesManager: "Placements.Opportunities.Manager",
  opportunitiesViewer: "Placements.Opportunities.Viewer",
  studentPlacementsManager: "Placements.Students.Manager"
};